<template>
  <div>
    <form method="post" name="contactform" @submit.prevent="sendMessage" id="contactform" autocomplete="on" novalidate>
      <div class="row">
        <div class="col-md-6">
          <div class="input-with-icon-left">
            <input class="with-border" name="name" v-model="$v.name.$model" type="text" id="name"
              placeholder="Your Name" required="required" />
            <i>
              <AccountCircleOutline :size="19" class="icon"></AccountCircleOutline>
            </i>
            <p class="text-danger" v-if="$v.name.$dirty && !$v.name.required">
              Name is required.
            </p>
          </div>
        </div>

        <div class="col-md-6">
          <div class="input-with-icon-left form-group">
            <input class="with-border form__input" v-model="$v.email.$model" name="email" type="email" id="email"
              placeholder="Email Address"
              pattern="^[A-Za-z0-9](([_\.\-]?[a-zA-Z0-9]+)*)@([A-Za-z0-9]+)(([\.\-]?[a-zA-Z0-9]+)*)\.([A-Za-z]{2,})$"
              required="required" />
            <i>
              <Email :size="19" class="icon"></Email>
            </i>
            <div class="text-danger" v-if="$v.email.$dirty && !$v.email.required">
              Email is required.
            </div>
            <div class="text-danger" v-if="$v.email.$dirty && !$v.email.email">
              Invalid email address.
            </div>
          </div>
        </div>
      </div>

      <div class="input-with-icon-left">
        <input class="with-border" v-model="$v.phone.$model" name="phone" type="tel" id="phone" placeholder="Phone" />
        <i>
          <Phone :size="19" class="icon"></Phone>
        </i>

      </div>

      <div class="input-with-icon-left">
        <input class="with-border" v-model="$v.subject.$model" name="subject" type="text" id="subject"
          placeholder="Subject" required="required" />
        <i>
          <ClipboardTextOutline :size="19" class="icon"></ClipboardTextOutline>
        </i>
        <div class="text-danger" v-if="$v.subject.$dirty && !$v.subject.required">
          Subject is required.
        </div>
      </div>

      <div>
        <textarea class="with-border" v-model="$v.message.$model" name="comments" cols="40" rows="5" id="comments"
          placeholder="Message" spellcheck="true" required="required"></textarea>
        <div class="text-danger" v-if="$v.message.$dirty && !$v.message.minLength">
          Message must have at least {{ $v.message.$params.minLength.min }} letters.
        </div>
        <div class="text-danger" v-if="$v.message.$dirty && !$v.message.required">
          Message is required.
        </div>
      </div>

      <input type="submit" class="submit button margin-top-15" id="submit" value="Submit Message" />
    </form>


  </div>
</template>

<script>
import { required, email, minLength } from "vuelidate/lib/validators";
import { sendEmail } from "../../services/api/email";
import AccountCircleOutline from "icons/AccountCircleOutline";
import Email from "icons/EmailOutline";
import Phone from "icons/PhoneOutline";
import ClipboardTextOutline from "icons/ClipboardTextOutline";

export default {
  components: {
    AccountCircleOutline,
    Email,
    Phone,
    ClipboardTextOutline
  },
  data() {
    return {
      name: "",
      email: "",
      phone: "",
      subject: this.initialSubject, // Initialize from prop
      message: this.initialMessage // Initialize from prop
    };
  },
  props: {
    initialSubject: {
      type: String,
      default: ''
    },
    initialMessage: {
      type: String,
      default: ''
    },
    initialTo: { // Adding initialTo prop
      type: String,
      default: 'info@macherusa.com' // Default to address, change as needed
    },
    initialCc: { // Adding initialCc prop
      type: String,
      default: '' // Default cc address, leave empty if no default needed
    }

  },
  validations: {
    name: { required },
    email: { required, email },
    phone: { required },
    subject: { required },
    message: { required, minLength: minLength(3) }
  },
  methods: {
    sendMessage() {

      this.$v.$touch();
      if (this.$v.$error) {
        // this.$toasted.global.emailNotSent();
        return;
      }

      this.doSendMessage();
    },
    async doSendMessage() {
      $nuxt.$root.$loading.start();

      var self = this;
      const emailTemplate = {
        to: this.initialTo,
        cc: this.initialCc,
        subject: "Contact Us -  " + this.subject,
        replyTo: {
          email: this.email,
          name: this.name
        },
        content: [
          {
            type: "text/html",
            value: `Email: ${this.email}<br />Name: ${this.name}<br />Phone: ${this.phone}<br /><br />Message:<br /><br />${this.message}`
          }
        ]
      };
      try {
        return await this.$mailer
          .sendEmail(emailTemplate)
          .then(response => {
            $nuxt.$root.$loading.finish();

            if (response.success) {
              self.$toasted.global.emailSent();
            } else {
              self.$toasted.global.emailNotSent();
            }
          })
          .catch(() => {
            $nuxt.$root.$loading.finish();
            self.$toasted.global.emailNotSent();
          });
      } catch (e) {
        this.error = e.response
          ? e.response.data.message
          : "Error while sending message";
      }

      sendEmail(data, {
        params: {
          identifier: "contacts_support_form"
        }
      })
        .then(response => {
          if (response.data) {
            self.$toasted.global.emailSent();
            console.log("Successfully received your message");
          } else {
            self.$toasted.global.emailNotSent();
          }
        })
        .catch(() => {
          self.$toasted.global.emailNotSent();
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.icon {
  position: relative;
  bottom: -2.5px;
}
</style>
